/* eslint-disable @typescript-eslint/naming-convention */
import type React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { TShirtIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface UpperBodyAttributeCardProps extends WithDataTestid, WithClassNameProp {
  size?: 'medium' | 'large';
  values: {
    sleeve: {
      length: string;
    };
    upper_clothing: {
      colors: string[];
    };
  };
}

export function UpperBodyAttributeCard({
  values,
  className = undefined,
  'data-testid': dataTestId = 'UpperBodyAttributeCard',
  ...props
}: UpperBodyAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  const { sleeve, upper_clothing } = values;

  const sleeveTypeLabel = EVENT_ENUMS.UPPER_BODY.SLEEVE[sleeve?.length]?.label;

  const colorsConfig = upper_clothing?.colors.map((color) => {
    return { color, tooltip: EVENT_ENUMS.UPPER_BODY.UPPER_CLOSING_COLOR[color]?.label };
  });

  return (
    <AttributeCard
      className={className}
      colorsConfig={colorsConfig}
      data={sleeve?.length === 'undefined' ? null : sleeve?.length}
      data-testid={dataTestId}
      description={`${sleeveTypeLabel} ${t('shared:attribute_cards.upper_body.sleeve')}`}
      icon={<TShirtIcon />}
      title={t('shared:attribute_cards.upper_body.title')}
      {...props}
    />
  );
}
